export const routesConfig = {
  exact: true,
  strict: true,
  sensitive: true
};

export default { routesConfig };
